/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Line_Spacing_LabelInputs */

const en_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line Spacing (%)`)
};

const fr_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interligne (%)`)
};

const de_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilenabstand (%)`)
};

const it_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interlinea (%)`)
};

const ru_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Межстрочный интервал (%)`)
};

const es_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interlineado (%)`)
};

const zh_cn2_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行间距 (%)`)
};

const ja_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行間隔（％）`)
};

const hi_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंक्ति रिक्ति (%)`)
};

const pt_pt2_options_display_line_spacing_label = /** @type {(inputs: Options_Display_Line_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaçamento entre linhas (%)`)
};

/**
* | output |
* | --- |
* | "Line Spacing (%)" |
*
* @param {Options_Display_Line_Spacing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_line_spacing_label = /** @type {((inputs?: Options_Display_Line_Spacing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Line_Spacing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_line_spacing_label(inputs)
	if (locale === "de") return de_options_display_line_spacing_label(inputs)
	if (locale === "it") return it_options_display_line_spacing_label(inputs)
	if (locale === "ru") return ru_options_display_line_spacing_label(inputs)
	if (locale === "es") return es_options_display_line_spacing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_line_spacing_label(inputs)
	if (locale === "ja") return ja_options_display_line_spacing_label(inputs)
	if (locale === "hi") return hi_options_display_line_spacing_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_line_spacing_label(inputs)
	return en_options_display_line_spacing_label(inputs)
});